export default __webpack_public_path__ + "static/media/all-offer-card3.f4f331d9.png";